import { ComparisonOperators } from '@contentsquare/fov-constants';
export const customerVariableCondition = {
    id: 'custom-variable',
    category: 'conditions',
    value: {
        numberValues: [
            { value: 1, label: 'NUMBER1' },
            { value: 2, label: 'NUMBER2' },
            { value: 3, label: 'NUMBER3' },
            { value: 4, label: 'NUMBER4' },
            { value: 5, label: 'NUMBER5' },
            { value: 6, label: 'NUMBER6' },
            { value: 7, label: 'NUMBER7' },
            { value: 8, label: 'NUMBER8' },
            { value: 9, label: 'NUMBER9' },
            { value: 10, label: 'NUMBER10' },
            { value: 11, label: 'NUMBER11' },
            { value: 12, label: 'NUMBER12' },
            { value: 13, label: 'NUMBER13' },
            { value: 14, label: 'NUMBER14' },
            { value: 15, label: 'NUMBER15' },
            { value: 16, label: 'NUMBER16' },
            { value: 17, label: 'NUMBER17' },
            { value: 18, label: 'NUMBER18' },
            { value: 19, label: 'NUMBER19' },
            { value: 20, label: 'NUMBER20' },
        ],
        targetValues: [
            { value: 'visitor', label: 'THE_USER' },
            { value: 'page', label: 'THE_PAGE' },
            { value: 'visit', label: 'THE_VISIT' },
        ],
        typeValues: [
            { value: 'key', label: 'KEY' },
            { value: 'value', label: 'VALUE' },
        ],
        operatorValues: [
            { value: ComparisonOperators.NOT_IS_EMPTY, label: 'CONDITION_SELECT_EXISTS' },
            { value: ComparisonOperators.MATCH_EQUALS, label: 'CONDITION_SELECT_IS_EQUAL_TO_FEMALE' },
            { value: ComparisonOperators.MATCH_REGEX, label: 'CONDITION_SELECT_CONTAINS' },
            { value: ComparisonOperators.DOES_NOT_MATCH_REGEX, label: 'CONDITION_SELECT_DOES_NOT_CONTAIN' },
            { value: ComparisonOperators.IS_EMPTY, label: 'CONDITION_SELECT_IS_EMPTY' },
        ],
    },
};
//# sourceMappingURL=custom-variable-condition.value.js.map